import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import { createTRPCContext } from '@trpc/tanstack-react-query';
import type { AppRouter } from '../server/app.router.server';

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>();

export type TrpcInput = inferRouterInputs<AppRouter>;
export type TrpcOutput = inferRouterOutputs<AppRouter>;
